import { useState } from 'react';
import { useModalContext } from '../../CustomModal/ModalProvider.jsx';
import imgExcluir from '../../../../src/assets/icons/confirmar.png';
import Swal from 'sweetalert2';

const FUSalvarButton = ({ handleUpload, nome_arquivo }) => {
  const [isClicked, setIsClicked] = useState(false);
  const { showWarning, showConfirm, showSuccess, showError, hideModal  } = useModalContext();

  /*const handleSalvar = async () => {
    try {

      handleUpload();
      setIsClicked(!isClicked);


    } catch (error) {
      console.log('error', error);
       showError('Erro!', 'Falha ao excutar a operação. Por favor, tente novamente.');
    }
  };*/

  const handleSalvar = async () => {
    try {
      await handleUpload();
      setIsClicked(!isClicked);
    } catch (error) {
      // EnviarFile / handleUpload já exibem o erro da API; evita modal genérico duplicado
      console.error('Falha ao salvar arquivo:', error);
    }
  };

  const confirmSalvar = async (nome_arquivo) => {
    const confirmado = await showConfirm(
      'Confirmação',
      `Tem certeza que deseja incluir o arquivo ${nome_arquivo}?`
    );
  
    if (confirmado) {
      handleSalvar(nome_arquivo);
    } else {
      hideModal();
    }
  };
  

  /*const confirmSalvar = (nome_arquivo) => {
    Swal.fire({
      title: 'Confirmação',
      text: 'Tem certeza que deseja incluir o arquivo ' + nome_arquivo +'?',
      text: 'Tem certeza que deseja incluir o arquivo ' + nome_arquivo + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'var(--accent)',
      confirmButtonText: 'Sim, salvar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        handleSalvar(nome_arquivo);
      }
    });
  };*/


  const buttonStyles = {
    backgroundImage: `url(${imgExcluir})`,
    backgroundSize: 'contain',
    width: '20px',
    height: '20px',
    backgroundColor: isClicked ? 'var(--info)' : 'var(--surface-3)',
    color: isClicked ? 'var(--text-primary)' : 'var(--text-on-accent)',
    border: '2px solid',
    borderRadius: '20px',
    //padding: '15px',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'background-color 0.3s, box-shadow 0.3s, transform 0.3s',
    boxShadow: isClicked ? 'none' : 'var(--shadow-sm)',
    transform: isClicked ? 'translate(2px, 2px)' : 'translate(0, 0)',
  };

  if (!isClicked) {
    buttonStyles.color = 'var(--text-primary)';
  }

  return (
    <div style={{ width: '100%', padding: '5px' }}>
      <button
        style={buttonStyles}
        onMouseEnter={(e) => {
          if (!isClicked) {
            e.target.style.transform = 'translate(-2px, -2px)';
            e.target.style.boxShadow = 'var(--shadow-md)';
            e.target.style.backgroundColor = 'var(--warning)';
            e.target.style.border = '2px solid green';
            e.target.style.color = 'var(--text-on-accent)';
          }
        }}
        onMouseDown={(e) => {
          if (!isClicked) {
            e.target.style.backgroundColor = 'var(--accent-soft)';
            e.target.style.boxShadow = 'none';
            e.target.style.transform = 'translate(1px, 1px)';
          }
        }}
        onMouseUp={(e) => {
          if (!isClicked) {
            e.target.style.backgroundColor = 'var(--accent-soft)';
            e.target.style.boxShadow = 'none';
            e.target.style.transform = 'translate(0, 0)';
            confirmSalvar(nome_arquivo);
          }
        }}
        onMouseLeave={(e) => {
          if (!isClicked) {
            e.target.style.transform = 'translate(0, 0)';
            e.target.style.boxShadow = 'var(--shadow-sm)';
            e.target.style.backgroundColor = 'var(--surface-3)';
            e.target.style.border = '2px solid white';
            e.target.style.color = 'var(--text-primary)';
          }
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
      </button>
    </div>
  );
};

export default FUSalvarButton;
